const CalendarType = {
    Day: "day",
    FourDay: "4day",
    Week: "week",
    Month: "month"
}

export default CalendarType;
